import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import functionsService from '../../services/Configurator/FunctionsService';

import { Characteristic, ValueDefinition, MapCharacteristicAndValue, ConfigurationContext } from '../../configurator/types';
import * as helper from '../../configurator/Helpers/StoreHelpers';
import * as cylinderCalculations from '../../configurator/CalculatedCharacteristics/CylinderCharacteristic';
import * as calculatedCharacteristics from '../../configurator/CalculatedCharacteristics/ExteriorAccessoryCharacteristics';
import store from '@/store/index';
import {beschlagLLTValue, beschlagNoLLTWarning} from "@/configurator/CalculatedCharacteristics/BeschlagCharacteristic";

function sleep(milliseconds : any) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

const getDefaultState = () => {
    return {
        model: {
            modelUnlocked: false,
            characteristics: [],
            modelStatus: {
                active: false,
            },
        },
        electronicOpenersCharacteristics: [
            { order: 1, code: 'KTU_MM_EOEFFNER_1', value: 'KEIN', customValue: 'KEIN' },
            { order: 2, code: 'KTU_MM_EOEFFNER_2', value: 'KEIN', customValue: 'KEIN' },
            { order: 3, code: 'KTU_MM_EOEFFNER_3', value: 'KEIN', customValue: 'KEIN' },
            { order: 4, code: 'KTU_MM_EOEFFNER_4', value: 'KEIN', customValue: 'KEIN' },
        ],
        electronicClosersCharacteristics: [
            { order: 1, code: 'KTU_MM_TUERSCHLIESSER_1', value: 'KEIN', customValue: 'KEIN' },
            { order: 2, code: 'KTU_MM_TUERSCHLIESSER_2', value: 'KEIN', customValue: 'KEIN' },
            { order: 3, code: 'KTU_MM_TUERSCHLIESSER_3', value: 'KEIN', customValue: 'KEIN' },
            { order: 4, code: 'KTU_MM_TUERSCHLIESSER_4', value: 'KEIN', customValue: 'KEIN' },
        ],
        bohrungazStatus: false,
        beschlagNoLLT: false
    };
};

const state = getDefaultState();

const addSingleCharacteristicsFilteredOrDefaults = (s: any) => {
    const exteriorAccessoriesCharacteristics = s.model.characteristics;
    const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
    exteriorAccessoriesCharacteristics.forEach((char: any) => {
        if (char.values.length === 1) {
            const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[0]);
            currentDoorConfiguration.Add(DoorConfiguration.ExteriorAccessory, selectedCharacteristic);
        } else {
            var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
            const regChar = geter(char.code, DoorConfiguration.ExteriorAccessory);
            const characteristicExists = regChar.id === char.id;

            const registeredValue = char.values.filter((x: any) => x.id === regChar.value.id)[0];
            const incorrectValue = typeof registeredValue === 'undefined' ? true : false;

            if (characteristicExists === false || incorrectValue === true) {
                let valueItem: any;

                for (const iterator of char.values) {
                    if (iterator.default === 1) {
                        valueItem = iterator;
                        break;
                    } else {
                        valueItem = char.values[0];
                    }
                }

                const selectedCharacteristic2 = MapCharacteristicAndValue(char, valueItem);
                currentDoorConfiguration.Add(DoorConfiguration.ExteriorAccessory, selectedCharacteristic2);
            }
        }
    });
 };

 const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};

const getCharacteristic = (code: string, s: any) => {
    const model = s.model;
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const checkValue = (characteristicCode: string, value: string, s: any) => {
    const definedValues = store.getters['configuratorModule/getCurrentDoorConfiguration'].Get(DoorConfiguration.ExteriorAccessory);
    const filteredCharacteristic: any = definedValues.filter((item: any) => item.code === characteristicCode && item.value.value === value)[0];

    if (filteredCharacteristic != null || typeof filteredCharacteristic !== 'undefined') {
        return true;
    }
    return false;
};

const getNrOfValues = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];
    if (typeof filteredCharacteristic !== 'undefined') {

        return filteredCharacteristic.values.length;
    } else {
        return 0;
    }
};

const getAppropValue = (characteristicCode: string, context: any) => {
    const characteristic = getCharacteristic(characteristicCode, context.state);
    var getter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
    const registeredCharacteristic = getter(characteristicCode, DoorConfiguration.ExteriorAccessory);
    let valueDefinition;

    if (characteristic.values.length > 1) {
        valueDefinition = characteristic.values.filter((x: any) => x.id !== registeredCharacteristic.value.id)[0];
    } else {
        valueDefinition = characteristic.values[0];
    }

    const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
    return selectedCharacteristic;
};

const getOpenerAppropValue = (characteristicCode: string, valueDefinition: ValueDefinition, context: any) => {
    const characteristic = getCharacteristic(characteristicCode, context.state);
    var getter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
    const registeredCharacteristic = getter(characteristicCode, DoorConfiguration.ExteriorAccessory);

    let valueDef;

    if (characteristic.values.length > 1) {
        valueDef = characteristic.values.filter((x: any) => x.id !== registeredCharacteristic.value.id)[0];
    } else {
        valueDef = characteristic.values[0];
    }

    const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDef);
    return selectedCharacteristic;
};

const checkIsOpenerChecked = (valueDefinition: ValueDefinition, s: any) => {
    // debugger;
    // const valueDefinitionVal = spliceDefinitionValue(valueDefinition);
    if (valueDefinition.value !== 'KEIN') {
        for (const iterator of s.electronicOpenersCharacteristics) {
            const valueExists = iterator.customValue === valueDefinition.value;
            if (valueExists === true) {
                return true;
            }
        }
    } else {
        for (const iterator of s.electronicOpenersCharacteristics) {
            if (iterator.customValue !== 'KEIN') {
                return false;
            } else {
                return true;
            }
        }
    }
    return false;
};

const checkOpenerAvailability = (valueDefinition: ValueDefinition, s: any) => {
    // const valueDefinitionVal = spliceDefinitionValue(valueDefinition);
    let checkBoxDisabled1: boolean = false;
    let nrOfLLTDefined: number = 0;

    for (const iterator of s.electronicOpenersCharacteristics) {
        const valueExists = iterator.customValue === valueDefinition.value;

        if (valueExists === true) {
            checkBoxDisabled1 = false;
            break;
        } else {
            checkBoxDisabled1 = true;
        }
    }

    for (const iterator of s.electronicOpenersCharacteristics) {
        if (iterator.customValue !== 'KEIN') {
            nrOfLLTDefined++;
        }
    }

    const checkBoxDisabled = nrOfLLTDefined === 4 && checkBoxDisabled1 === true;

    return checkBoxDisabled;
};

const checkCloserAvailability = (valueDefinition: ValueDefinition, s: any) => {
    // const valueDefinitionVal = spliceDefinitionValue(valueDefinition);
    let checkBoxDisabled1: boolean = false;
    let nrOfLLTDefined: number = 0;

    for (const iterator of s.electronicClosersCharacteristics) {
        const valueExists = iterator.customValue === valueDefinition.value;

        if (valueExists === true) {
            checkBoxDisabled1 = false;
            break;
        } else {
            checkBoxDisabled1 = true;
        }
    }

    for (const iterator of s.electronicClosersCharacteristics) {
        if (iterator.customValue !== 'KEIN') {
            nrOfLLTDefined++;
        }
    }

    const checkBoxDisabled = nrOfLLTDefined === 4 && checkBoxDisabled1 === true;

    return checkBoxDisabled;
};

const checkIsCloserChecked = (valueDefinition: ValueDefinition, s: any) => {
    // const valueDefinitionVal = spliceDefinitionValue(valueDefinition);
    if (valueDefinition.value !== 'KEIN') {
        for (const iterator of s.electronicClosersCharacteristics) {
            const valueExists = iterator.customValue === valueDefinition.value;
            if (valueExists === true) {
                return true;
            }
        }
    } else {
        for (const iterator of s.electronicClosersCharacteristics) {
            if (iterator.customValue !== 'KEIN') {
                return false;
            } else {
                return true;
            }
        }
    }
    return false;
};

const spliceDefinitionValue = (valueDefinition: ValueDefinition): string => {
    if (valueDefinition.value === 'KEIN') {
        return valueDefinition.value;
    }

    const underscoreIndex = valueDefinition.value.indexOf('_', 0);
    const numberOfChars = valueDefinition.value.length;
    const valueDefinitionVal: string = valueDefinition.value.slice(underscoreIndex + 1, numberOfChars);

    return valueDefinitionVal;
};

const getters = {
    getExteriorAccessoryCharacteristics: (s: any) => s.model.characteristics,
    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
    checkRadioValue: (s: any) => {
        return (characteristicCode: string, value: string) => checkValue(characteristicCode, value, s);
    },
    getNrOfValuesByCharacteristic: (s: any) => {
        return (characteristicCode: string) => getNrOfValues(characteristicCode, s);
    },
    getElectronicOpeners(s: any) {
        const values = s.model.characteristics.filter((item: any) => item.code === 'CUST_MM_EOEFFNER')[0].values; // KTU_MM_EOEFFNER_1
        return values;
    },
    getElectronicClosers(s: any) {
        const values = s.model.characteristics.filter((char: any) => char.code === 'CUST_MM_TUERSCHLIESSER')[0].values; // KTU_MM_TUERSCHLIESSER_1
        return values;
    },
    isOpenerChecked: (s: any) => {
        return (valueDefinition: ValueDefinition) => checkIsOpenerChecked(valueDefinition, s);
    },
    openerAvailability: (s: any) => {
        return (valueDefinition: ValueDefinition) => checkOpenerAvailability(valueDefinition, s);
    },
    isCloserChecked: (s: any) => {
        return (valueDefinition: ValueDefinition) => checkIsCloserChecked(valueDefinition, s);
    },
    closerAvailability: (s: any) => {
        return (valueDefinition: ValueDefinition) => checkCloserAvailability(valueDefinition, s);
    },
    getElectronicOpenersCharacteristics(s: any) {
        return s.electronicOpenersCharacteristics;
    },
    getTransponderControlsStatus: (s: any) => {

        return calculatedCharacteristics.transponderControlsStatus();
    },
    getBohrungazStatus: (s: any) => {
        return s.bohrungazStatus;
    },
    getBeschlagNoLLT: (s: any) => {
        return s.beschlagNoLLT
    }
};

const actions = {
    resetState(context: any) {
        context.commit('resetState');
    },
    setExteriorAccessoriesCharacteristics(context: any, payload: any) {
        context.commit('updateExteriorAccessoriesCharacteristics', payload);
    },
    addCharacterisitc(context: any, { characteristic, valueDefinition }: any) {
        return new Promise((resolve, reject) => {
            const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
            const configuration = context.rootState.configuratorModule.doorConfiguration;
            configuration.Add(DoorConfiguration.ExteriorAccessory, selectedCharacteristic);

            if (selectedCharacteristic.code === 'KTU_MM_FUNKTION_EN1125' || selectedCharacteristic.code === 'KTU_MM_FUNKTION_EN179') {
                context.commit('updateSpecialLockValues');
            }
            resolve();
        });
    },
    valueAddCharacteristic(context: any, { characteristicValue, value }: any) {
        characteristicValue.values[0].value = value;
        const selectedCharacteristic = MapCharacteristicAndValue(characteristicValue, characteristicValue.values[0]);
        context.rootState.configuratorModule.doorConfiguration.AddNumericCharacteristic(DoorConfiguration.ExteriorAccessory, selectedCharacteristic);
    },
    checkBoxAddCharacteristic(context: any, characteristicCode: string) {
        const char: Characteristic = getAppropValue(characteristicCode, context);
        context.rootState.configuratorModule.doorConfiguration.Add(DoorConfiguration.ExteriorAccessory, char);
    },
    setSingleCharacteristicsFilteredOrDefaults(context: any) {
        context.commit('updateSingleCharacteristicsFilteredOrDefaults');
    },
    setCharacteristicDependencies(context: any, {chacrateristicCode, characteristicCodeAfterMain}: any) {
        var modelExteriorAccessoryCharacteristics = context.getters.getExteriorAccessoryCharacteristics;
        const anchor: any = modelExteriorAccessoryCharacteristics.filter((item: any) => item.code === chacrateristicCode)[0];
        const doorConfiguration = context.rootState.configuratorModule.doorConfiguration;
        const filteredDependencies = doorConfiguration.GetDependenciesByCharacteristic(chacrateristicCode);

        return new Promise((resolve, reject) => {
            functionsService.extractDependencies(anchor.id, filteredDependencies)
                .then((response: any) => {
                    context.commit('updateCharacteristicDependencies', response.data);
                    resolve();
                });
        });
    },

    setRIEGELSCHALTKONTAKT(context: any, value: boolean)
    {
        
        const riegelschaltKontaktCharacteristic = context.rootState.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_RIEGELSCHALTKONTAKT')[0];
        const riegelschaltKontaktValue = riegelschaltKontaktCharacteristic.values.filter((v: ValueDefinition) => v.value === "LLT450002")[0];
        const riegelschaltKontaktNeinValue = riegelschaltKontaktCharacteristic.values.filter((v: ValueDefinition) => v.value === "NEIN")[0];

        if(value)
        {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_RIEGELSCHALTKONTAKT', riegelschaltKontaktValue.value);
        }else {
            context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_RIEGELSCHALTKONTAKT', riegelschaltKontaktNeinValue.value);
        }
    },
    

    setCylinder(context: any) {

        const cylinderVal: ValueDefinition = cylinderCalculations.getZylinderLLTValue();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_ZYLINDER', cylinderVal);

        const cylinderLength = cylinderCalculations.calculateCylinderLength();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_ZYLINDERLAENGE_INNEN', cylinderLength.cylinderLengthInside);
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_ZYLINDERLAENGE_AUSSEN', cylinderLength.cylinderLengthOutside);
    },
    setNumberOfSpies(context: any) {
        const numberOfSpies = calculatedCharacteristics.calculateSPIONVERLANZ();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_SPIONVERL_ANZ', numberOfSpies);
    },
    setSpecialLockLLTNumber(context: any) {
        const specialLockLLT = calculatedCharacteristics.specialLockLLT();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_VERRIEGELUNG_SONDER', specialLockLLT);
    },
    setPlateDistances(context: any) {
        const plateDistances = calculatedCharacteristics.calculatePlateDistances();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_KR_DISTANZPL_1_ANZ', plateDistances.plateDistance1);
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_KR_DISTANZPL_5_ANZ', plateDistances.plateDistance5);
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_KR_DISTANZPL_12_ANZ', plateDistances.plateDistance12);
    },
    setOuterCylinderDrilling(context: any) {
        const drillingLength = calculatedCharacteristics.calculateBOHRUNGAZ();
        const statusBohrungAz = calculatedCharacteristics.bohrungazStatus();
        context.commit('updateBohrungazStatus', statusBohrungAz);
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.ExteriorAccessory, 'KTU_MM_BOHRUNG_AZ', drillingLength);
    },
    setStandardLockDependantCharacteristics(context: any) {
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_SCHLOSS', calculatedCharacteristics.schloss());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_SCHLIESSLEISTE', calculatedCharacteristics.schliessleiste());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_BANDSICHERUNG', calculatedCharacteristics.bandsicherung());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_STAHLSTULPLEISTE', calculatedCharacteristics.stahlstulplesite());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_VERR_BOLZEN', calculatedCharacteristics.verrBolzen());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_VERR_BSTIFT', calculatedCharacteristics.verrBstift());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_VERR_BSTIFT_ANZ', calculatedCharacteristics.verrBstiftAnz());
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_VERR_BOLZEN_ANZ', calculatedCharacteristics.verrBolzenAnz());
    },
    setBeschlagLLTValue(context: any) {
        let getBeschlagValue = beschlagLLTValue();
        let getBeschlagNoLLTWarning = beschlagNoLLTWarning();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_BESCHLAG', getBeschlagValue);
        context.commit('setBeschlagNoLLT', getBeschlagNoLLTWarning)
    },
    setZUBEHOER(context: any){
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.ExteriorAccessory, 'KTU_MM_ZUBEHOER', calculatedCharacteristics.getZUBEHOER());
    },
    addCheckBoxOpenerCharacteristic(context: any, valueDefinition: ValueDefinition) {
        const valueDefinitionVal = spliceDefinitionValue(valueDefinition);
        if (valueDefinitionVal !== 'KEIN') {
            const openerItemValuated = state.electronicOpenersCharacteristics.filter((item: any) => item.customValue === valueDefinition.value)[0];

            // value not exists, then add it
            if (typeof openerItemValuated === 'undefined') {
                const openerItem = state.electronicOpenersCharacteristics.filter((item: any) => item.customValue === 'KEIN')[0];
                openerItem.value = valueDefinitionVal;
                openerItem.customValue = valueDefinition.value;
            } else {
                openerItemValuated.value = 'KEIN';
                openerItemValuated.customValue = 'KEIN';

                for (let i = 0; i < state.electronicOpenersCharacteristics.length - 1; i++) {
                    const item1 = state.electronicOpenersCharacteristics[i];
                    for (let j = i + 1; j < state.electronicOpenersCharacteristics.length; j++) {
                        const item2 = state.electronicOpenersCharacteristics[j];

                        if (item1.value === 'KEIN' && item2.value !== 'KEIN') {
                            item1.value = item2.value;
                            item1.customValue = item2.customValue;

                            item2.value = 'KEIN';
                            item2.customValue = 'KEIN';
                            break;
                        }
                    }
                }
            }
        } else {
            for (const iterator of state.electronicOpenersCharacteristics) {
                iterator.value = 'KEIN';
                iterator.customValue = 'KEIN';
            }
        }
        var getter = store.getters['configuratorModule/getRegisteredCharacteristicsValue']
        
        for (const iterator of state.electronicOpenersCharacteristics) {
            console.log("Code " + iterator.code)
            console.log("Value " + iterator.value)
            var c = context;
            
            const characteristic = getter(iterator.code, DoorConfiguration.ExteriorAccessory);
            
            console.log(characteristic.values);
            const storeCharacteristic = context.rootState.exteriorAccessoryModule.model.characteristics.filter((item: any) => item.code === iterator.code)[0];
                   
            const valueDef = storeCharacteristic.values.filter((item: any) => item.value === iterator.value)[0];

            const finalChar = MapCharacteristicAndValue(characteristic, valueDef);
            context.rootState.configuratorModule.doorConfiguration.Add(DoorConfiguration.ExteriorAccessory, finalChar);
        }
    },

    addCheckBoxCloserCharacteristic(context: any, valueDefinition: ValueDefinition) {
        const valueDefinitionVal = spliceDefinitionValue(valueDefinition);
        if (valueDefinitionVal !== 'KEIN') {
            const closerItemValuated = context.state.electronicClosersCharacteristics.filter((item: any) => item.customValue === valueDefinition.value)[0];

            // value not exists, then add it..
            if (typeof closerItemValuated === 'undefined') {
                const closerItem = context.state.electronicClosersCharacteristics.filter((item: any) => item.customValue === 'KEIN')[0];
                closerItem.value = valueDefinitionVal;
                closerItem.customValue = valueDefinition.value;
            } else {
                closerItemValuated.value = 'KEIN';
                closerItemValuated.customValue = 'KEIN';

                for (let i = 0; i < context.state.electronicClosersCharacteristics.length - 1; i++) {
                    const item1 = context.state.electronicClosersCharacteristics[i];
                    for (let j = i + 1; j < context.state.electronicClosersCharacteristics.length; j++) {
                        const item2 = context.state.electronicClosersCharacteristics[j];

                        if (item1.customValue === 'KEIN' && item2.customValue !== 'KEIN') {
                            item1.value = item2.value;
                            item1.customValue = item2.customValue;

                            item2.value = 'KEIN';
                            item2.customValue = 'KEIN';
                            break;
                        }
                    }
                }
            }
        } else {
            for (const iterator of context.state.electronicClosersCharacteristics) {
                iterator.value = 'KEIN';
                iterator.customValue = 'KEIN';
            }
        }

        for (const iterator of context.state.electronicClosersCharacteristics) {
            var getter = store.getters['configuratorModule/getRegisteredCharacteristicsValue']
            const characteristic = getter(iterator.code, DoorConfiguration.ExteriorAccessory);

            const storeCharacteristic = context.rootState.exteriorAccessoryModule.model.characteristics.filter((item: any) => item.code === iterator.code)[0];
                   
            const valueDef = storeCharacteristic.values.filter((item: any) => item.value === iterator.value)[0];

            const finalChar = MapCharacteristicAndValue(characteristic, valueDef);
            context.rootState.configuratorModule.doorConfiguration.Add(DoorConfiguration.ExteriorAccessory, finalChar);
        }
    },
    initExteriorAccessoryModule(context : any, payload : any)
    {
        context.commit('initExteriorAccessoryModule', payload);
    },
}

const getFileteredValueDefinition = (storeCharacteristic: any,iterator : any): any => {
    return storeCharacteristic.values.filter((item: any) => item.value === iterator.value)[0];
}

const mutations = {
    resetState(s: any) {
        Object.assign(s, getDefaultState());
    },
    updateExteriorAccessoriesCharacteristics(s: any, payload: any) {
        s.model.characteristics = payload.characteristics;

        const characteristic = calculatedCharacteristics.specialLockCustomValues();
        addOrReplaceCharacteristic(characteristic, s);
    },
    updateSingleCharacteristicsFilteredOrDefaults(s: any) {
        addSingleCharacteristicsFilteredOrDefaults(s);

        const characteristic = calculatedCharacteristics.specialLockCustomValues();
        addOrReplaceCharacteristic(characteristic, s);
    },
    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        // console.log(characteristic.code);
        if (typeof characteristic !== 'undefined') {
            addOrReplaceCharacteristic(characteristic, s);

            addSingleCharacteristicsFilteredOrDefaults(s);
        }
    },
    updateSpecialLockValues(s: any) {
        const characteristic = calculatedCharacteristics.specialLockCustomValues();
        addOrReplaceCharacteristic(characteristic, s);
        addSingleCharacteristicsFilteredOrDefaults(s);
    },
    initExteriorAccessoryModule(context : any, payload : any)
    {
        //init ExteriorAccessory Module here!
    },
    updateBohrungazStatus(context: any, status: boolean){
        context.bohrungazStatus = status;
    },
    setBeschlagNoLLT(s: any, payload: boolean){
        s.beschlagNoLLT = payload
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
